import { createAction } from '@ngrx/store';

export const OpenLiteralsSidenav = createAction('[Literals: Sidenav]: Sidenav Opened');

export const CloseLiteralsSidenav = createAction('[Literals: Sidenav]: Sidenav Closed');
